let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("clAYE")).then(() => parcelRequire('a4wtg'));